type TLicensePair = {
  basic?: number | null;
  additional?: number | null;
};

type TStaffLicenses = {
  issued?: TLicensePair | null;
  remainder?: TLicensePair | null;
};

type TStatisticsLicensesResponse = {
  basicLicensesIssued?: number | null;
  additionalLicensesIssued?: number | null;
  basicLicensesRemaining?: number | null;
  additionalLicensesRemaining?: number | null;
};

export const mapStatisticsLicenses = (
  licenses?: TStatisticsLicensesResponse | null,
): TStaffLicenses | undefined => {
  if (!licenses) {
    return undefined;
  }

  return {
    issued: {
      basic: licenses.basicLicensesIssued,
      additional: licenses.additionalLicensesIssued,
    },
    remainder: {
      basic: licenses.basicLicensesRemaining,
      additional: licenses.additionalLicensesRemaining,
    },
  };
};

const formatPart = (value?: number | null) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return " - ";
  }

  return String(value);
};

export const formatLicensePair = (pair?: TLicensePair | null) => {
  if (!pair) {
    return " - ";
  }

  return `${formatPart(pair.basic)}/${formatPart(pair.additional)}`;
};

export const getStaffLicensesValue = (
  licenses: TStaffLicenses | null | undefined,
  type: "issued" | "remainder",
) => formatLicensePair(licenses?.[type]);
